import { render } from "./TableFooter.vue?vue&type=template&id=6244d88a"
import script from "./TableFooter.vue?vue&type=script&lang=js"
export * from "./TableFooter.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__